import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }                          from 'ng-block-ui';
import { NgbActiveModal }                              from '@ng-bootstrap/ng-bootstrap';

import { CompanyMessagesModel }             from '../companies/models/company.messages';
import { CustomerModel }                    from './models/customer';
import { CustomerStatementFieldsComponent } from './customer.statement-fields.component';
import { CustomerStatementSettingsModel }   from './typings/customer.statement-settings';
import { FlipperSidesModel }                from '../shared/components/flipper/typings/flipper.sides';
import { MessagesService }                  from '../messages/messages.service';
import { MessengerEmailParamsModel }        from '../messages/messenger/typings/messenger.email-params';
import { MessengerService }                 from '../messages/messenger/messenger.service';
import { TemplatedWordingService }          from '../templates/templated-wording.service';
import { TemplateModel }                    from '../templates/typings/template';

@Component({
  selector   : 'wor-email-customer-statement',
  template: require('./customer.email-statement.component.html')
})
export class EmailCustomerStatementComponent implements OnInit {
  @BlockUI('customerStatementEmailBlock') block: NgBlockUI;

  @Input() companyMessages: CompanyMessagesModel;
  @Input() customer       : CustomerModel;

  activeSide: FlipperSidesModel              = 'front';
  email     : MessengerEmailParamsModel      = {};
  settings  : CustomerStatementSettingsModel = CustomerStatementFieldsComponent.getDefaultSettings();

  constructor (
    public  activeModal            : NgbActiveModal,
    private changeDetectorRef      : ChangeDetectorRef,
    private messagesService        : MessagesService,
    private messengerService       : MessengerService,
    private templatedWordingService: TemplatedWordingService
  ) {}

  ngOnInit () : void {
    this.email = {
      attachment_filters: this.settings,
      attachment_id     : this.customer.id,
      attachment_type   : 1,
      body              : this.companyMessages.statement_email_message,
      email_address     : this.customer.email,
      name              : this.customer.display_name
    };
  }

  addTemplates () : void {
    this.templatedWordingService.addTemplate('email')
      .then(( templates : Array<TemplateModel> ) => {
        templates.forEach(template => {
          this.email.body = this.email.body
            ? `${ this.email.body }\n\n${ template.wording }`
            : template.wording;
        });
      })
      .catch(error => this.messagesService.error(error));
  }

  flip ( side : FlipperSidesModel ) : void {
    this.activeSide = side;

    this.changeDetectorRef.detectChanges();
  }

  send () : void {
    this.block.start();

    this.messengerService.sendEmail(this.email)
      .then(() => this.activeModal.close())
      .catch(error => this.messagesService.error(error))
      .finally(() => this.block.stop());
  }
}
